var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-4 mx-0 md:mx-12 lg:mx-0 mb-4 rounded-md bg-white"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }